import React, { useEffect, useState, useRef } from "react";
import {
  InteractiveMap,
  Layer,
  Marker,
  NavigationControl,
  Source,
  Popup,
} from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import "./MapComponent.css";
import { ReactComponent as EventPin } from "../assets/images/Group 1000004561.svg";
import { EnvironmentFilled, EnvironmentOutlined } from "@ant-design/icons";
import { ReactComponent as Pin } from "../assets/images/pin.svg";
import { ReactComponent as RedUnlock } from "../assets/images/red-unlock.svg";
import { ReactComponent as Lock } from "../assets/images/Lock.svg";
import { FaMapMarkerAlt } from "react-icons/fa";
import truckIcon from "../assets/images/noto_delivery-truck.png";
import { FaSyncAlt } from "react-icons/fa"; // Add this import at the top
import { RouteIcon } from "lucide-react";
import { ReactComponent as RouteIcons } from "../../../trackright-system-ui-uat/src/assets/images/RouteIcons.svg";
import { ReactComponent as Rectangle } from "../../../trackright-system-ui-uat/src/assets/images/rectangle.svg";
import { ReactComponent as Routeused } from "../../../trackright-system-ui-uat/src/assets/images/routeused.svg";
import styled from "styled-components";
import { ButtonFilled } from "./UIButtons";
import { Button } from "antd";
import * as turf from "@turf/turf";
import { WebMercatorViewport } from "react-map-gl";
import { SearchBox } from "@mapbox/search-js-react";
import mapboxgl from "mapbox-gl";
import { ReactComponent as LiveTrackone } from "../assets/livetracking/livetrackone.svg";
import { ReactComponent as LiveTrackFour } from "../assets/livetracking/livetrackfour.svg";
import { ReactComponent as VideoIcon } from "../assets/images/Video.svg";
import { ReactComponent as Videoon } from "../assets/images/Video-On.svg";
import { ReactComponent as Info } from "../assets/images/Info.svg";
import { ReactComponent as Infoon } from "../assets/images/Info-On.svg";
import { ReactComponent as SpeedIcon } from "../assets/images/speed (2).svg";
import { ReactComponent as SignalIcon } from "../assets/images/Signals-2.svg";
import { ReactComponent as Signal2 } from "../assets/images/signal-weak.svg";
import dayjs from "dayjs";
import moment from "moment";

const MAPBOX_TOKEN =
  "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";

const Newbox = styled.div`
  .CONTAINER_THREE_tracklink {
    margin-top: 8px;
    background-color: white;
    padding: 19px 04px 02px 04px;
    border-top-left-radius: 19px;
    border-top-right-radius: 19px;
  }
  .loca_one {
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    color: black;
  }

  .loca_two {
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    line-height: 100%;
    color: #979797;
  }
  .popup_header {
    display: flex;
    flex-direction: column;
    gap: 0px;
  }
  .popup_body {
    display: flex;
    justify-content: space-between;
    padding: 0px 5px 0px 5px !important;
  }


@media screen and (min-width: 320px) and (max-width: 427px) {
   .mapboxgl-popup-content {
    margin-left: -50% !important;
background-color:red!important; 
  }



  .mapboxgl-popup-content {
    background-color: #e1ffed !important;
    width: 350px !important;
    height: auto !important;
    padding: 4px 07px 0px 07px !important;
    z-index: 10 !important;
  }

  .map_container_viewpoints {
    display: flex !important;
    flex-direction: column;
    justify-content: center !important;
  }

  .map_satellite_toggle {
    display: flex;
    gap: 15px;
  }

  /* 

  @media screen and (min-width: 1025px) and (max-width: 1440px) {
    .map_container_REUSABLE_one {
      width: 50% !important;
      height: 50vh !important;
    }
    .map_container_REUSABLE_one > div[tabindex="0"] {
      height: 100% !important;
    }
  } */

  @media screen and (min-width: 320px) {
    .satellite_button_one {
      bottom: 60% !important;
      right: 14% !important;
      width: 40;
      height: 40;
      background-color: lightgray !important;
    }
    .satellite_button {
      top: 65% !important;
      right: 125px !important;
      width: 16% !important;
      height: 40;
    }
    .map_container_REUSABLE_one {
      width: 100% !important;
      height: 50vh !important;
      /* position:relative; */
    }
    .map_container_REUSABLE_one > div[tabindex="0"] {
      height: 100% !important;
    }
    .map_container_toggling {
      bottom: 1%;
    }

    button {
      outline: none;
      box-shadow: none;
    }

    button:focus {
      outline: none;
      box-shadow: none;
    }

    button:active {
      background-color: inherit;
      outline: none;
      box-shadow: none;
    }
  }

  @media screen and (min-width: 376px) and (max-width: 480px) {
    .satellite_button_one {
      top: 60% !important;
      right: 20% !important;
      width: 40;
      height: 40;
      background-color: red !important;
    }
    .satellite_button {
      top: 65% !important;
      right: 30% !important;
      width: 16% !important;
      height: 40;
      background-color: lightgray !important;
    }
    button {
      outline: none;
      box-shadow: none;
    }

    button:focus {
      outline: none;
      box-shadow: none;
    }

    button:active {
      background-color: inherit;
      outline: none;
      box-shadow: none;
    }
  }

  @media screen and (min-width: 481px) and (max-width: 768px) {
    .satellite_button_one {
      top: 60% !important;
      right: 14% !important;
      width: 40;
      height: 40;
      background-color: lightgray !important;
    }
    .satellite_button {
      top: 65% !important;
      right: 20% !important;
      width: 16% !important;
      height: 40;
    }
    button {
      outline: none;
      box-shadow: none;
    }

    button:focus {
      outline: none;
      box-shadow: none;
    }

    button:active {
      background-color: inherit;
      outline: none;
      box-shadow: none;
    }
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .satellite_button_one {
      top: 60% !important;
      right: 04% !important;
      width: 40;
      height: 40;
      background-color: lightgray !important;
    }
    .satellite_button {
      top: 65% !important;
      right: 08% !important;
      width: 16% !important;
      height: 40;
    }
    button {
      outline: none;
      box-shadow: none;
    }

    button:focus {
      outline: none;
      box-shadow: none;
    }

    button:active {
      background-color: inherit;
      outline: none;
      box-shadow: none;
    }
  }

  .satellite_button_two {
    padding: 4px 85px 4px 85px !important;
  }
  button {
    outline: none;
    box-shadow: none;
  }

  button:focus {
    outline: none;
    box-shadow: none;
  }

  button:active {
    background-color: inherit;
    outline: none;
    box-shadow: none;
  }
`;

const MapComponent = ({
  summaryData,
  tracklinkAiplus,
  trackLinktruckicon,
  triptracktruckicon,
  tripListData,
  driverNametracklinkplus,
  fromFiles,
  tracklinkplus = false,
  triprackAI = false,
  triptrack = true,
  trackLink = false,
  conatinericon,
  rGeoJSON,
  mapSize,
  routeData,
  resetTrigger,
  drawingMode,
  isEditing,
  onPolygonDraw,
  initialPolygon,
  showSearch = false,
  containerDetailMap,
  LiveVehicleDetailMap,
  LiveDeviceDetailMap,
  companyName,
  tripEvent,
  locationsTL = [], // tracking link event and triplist map tab
  locationsTLAI = [], // tracking link AI event and triplist map tab
  actualLocationsAI = [],
  timeandDistAI = [], // click vehicle
  containerplanedRoutes,
  data,
  status,
  route,
  pinlocation,
  consignmentMap,
  summaryData1,
  routeDetails,
  routePoints, //consignment locationtrab green line
  locationTab, //consignment locationtab event yellow pins
  isminimap = false,
  MapCoords = false,
  isHomePage = false,
  driverName = "", //AI eventspopup drivername
  locationName = "", //AI eventspopup locationName
  eventnames = "", //AI eventspopup eventnames
  mapType= "default", // to differentiate cargo and truck in map
}) => {
  const showLine = pinlocation?.length === 1;

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locationsRoute, setLocationsRoute] = useState(null);
  const [routeGeoJSON, setRouteGeoJSON] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [selectedMarkerIndex, setSelectedMarkerIndex] = useState(null);
  const [resolvedAddresses, setResolvedAddresses] = useState({});
  const [driverRouteGeoJSON, setDriverRouteGeoJSON] = useState(null);
  const [showActualRoute, setShowActualRoute] = useState(true);
  const [plannedContainerRoute, setPlannedContainerRoute] = useState(null);
  const [isSatellite, setIsSatellite] = useState(false);
  const [showTruckPopup, setShowTruckPopup] = useState(false);
  const [triptracklinklocation, setTriptracklinklocation] = useState(null);
  const [triptracklinklocationAI, setTriptracklinklocationAI] = useState(null);
  const [lastLocationName, setLastLocationName] = useState("");

  // Inside your MapComponent function or similar context
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  // useEffect(() => {
  //   const handleResize = () => {
  //     window.location.reload();
  //   };
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  const mapHeight = mapSize === "large" ? "700px" : "300px";
  const mapWidth = mapSize === "large" ? "100%" : "100%";
  const defaultViewport = {
    latitude: -6.7924,
    longitude: 39.2083,
    zoom: 5,
    width: "100%",
    height: "100vh",
  };

  const validEvents = (
    Array.isArray(locationsTLAI) ? locationsTLAI : []
  ).filter((loc) => !isNaN(parseFloat(loc.LAT)) && !isNaN(parseFloat(loc.LNG)));

  const lastEvent = validEvents?.[validEvents.length - 1];

  // Example function to get location name from lat/lng

  // const [viewport, setViewport] = useState({
  //   latitude: -1.286389, // Kenya
  //   longitude: 36.817223,
  //   zoom: 3,
  //   width: "100%",
  //   height: "100vh",
  // });

  // const fallbackLat = -6.7924;
  // const fallbackLng = 39.2083;

  const fallbackLat = -1.286389;
  const fallbackLng = 36.817223;
  const [viewport, setViewport] = useState({
    latitude: fallbackLat,
    longitude: fallbackLng,
    zoom: 10,
    width: "100%",
    height: "100vh",
  });

  const EVTYPE_MAP = {
    0: "Accepted",
    1: "Started",
    2: "Arrived PickUp Point",
    3: "Loading Started",
    4: "Loading Completed",
    5: "Journey Started",
    6: "Reached Delivery Point",
    7: "Offloading Started",
    8: "Offloading Completed",
    9: "Return Journey Started",
    10: "Returned to Base",
    11: "Finished",
  };
  const AIConsignmentDeliveryEvents = {
    1: "Started",
    13: "Delivery Journey Started",
    17: "Reached Delivery Point",
    18: "Return Journey Started",
    14: "Returned To Base",
    16: "Finished",
  };
  const handleMarkerClick = async (index, lat, lng) => {
    setSelectedMarkerIndex(index);

    const key = `${lat},${lng}`;

    // Only fetch if not already cached
    if (!resolvedAddresses[key]) {
      const address = await fetchLocation(lat, lng);
      setResolvedAddresses((prev) => ({
        ...prev,
        [key]: address,
      }));
    }
  };

  const formatDateTime = (datetimeStr) => {
    const date = new Date(datetimeStr);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const time = date.toLocaleTimeString("en-US", options);
    const dateStr = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    return `${time}, ${dateStr}`;
  };

  const getRouteFromMapbox = async (startLng, startLat, endLng, endLat) => {
    const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${startLng},${startLat};${endLng},${endLat}?geometries=geojson&access_token=${MAPBOX_TOKEN}`;

    const res = await fetch(url);
    const data = await res.json();
    return data?.routes?.[0]?.geometry || null;
  };

  useEffect(() => {
    if (locationTab?.locations?.length > 1) {
      const coords = locationTab.locations.map((loc) => [
        parseFloat(loc.Lng),
        parseFloat(loc.Lat),
      ]);
      const geojsonLine = {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: coords,
        },
      };
      setLocationsRoute(geojsonLine);
    }
  }, [locationTab]);
  useEffect(() => {
    const getLastLocationName = async () => {
      if (locationsTLAI && locationsTLAI.length > 0) {
        const lastLocation = locationsTLAI[locationsTLAI.length - 1];
        if (lastLocation?.LAT && lastLocation?.LNG) {
          const location = await fetchLocation(
            lastLocation.LAT,
            lastLocation.LNG
          );
          setLastLocationName(location);
        }
      }
    };
    getLastLocationName();
  }, [locationsTLAI]);
  // useEffect(() => {
  //   const fetchRoute = async () => {
  //     if (!Array.isArray(routePoints) || routePoints.length !== 2) return;

  //     const [start, end] = routePoints;

  //     const startLat = parseFloat(start?.lat) || fallbackLat;
  //     const startLng = parseFloat(start?.lng) || fallbackLng;
  //     const endLat = parseFloat(end?.lat) || fallbackLat;
  //     const endLng = parseFloat(end?.lng) || fallbackLng;

  //     const route = await getRouteFromMapbox(
  //       startLng,
  //       startLat,
  //       endLng,
  //       endLat
  //     );

  //     if (route) {
  //       setRouteGeoJSON({
  //         type: "Feature",
  //         geometry: route,
  //       });

  //       // Zoom logic here
  //       const centerLat = (startLat + endLat) / 2;
  //       const centerLng = (startLng + endLng) / 2;

  //       setViewport((prev) => ({
  //         ...prev,
  //         latitude: centerLat,
  //         longitude: centerLng,
  //         zoom: 10, // You can change zoom level here
  //       }));
  //     }
  //   };

  //   fetchRoute();
  // }, [routePoints]);

  // const renderGreenRouteAndYellowPins = () => {
  //   if (!Array.isArray(routePoints) || routePoints.length !== 2) return null;

  //   const [start, end] = routePoints;

  //   const startLat = parseFloat(start?.lat) || fallbackLat;
  //   const startLng = parseFloat(start?.lng) || fallbackLng;
  //   const endLat = parseFloat(end?.lat) || fallbackLat;
  //   const endLng = parseFloat(end?.lng) || fallbackLng;

  //   return (
  //     <>
  //       {/* Start Marker */}
  //       <Marker
  //         latitude={startLat}
  //         longitude={startLng}
  //         anchor="bottom"
  //         onClick={() => setSelectedLocation(start)}
  //       >
  //         <div style={{ textAlign: "center" }}>
  //           <EnvironmentFilled style={{ fontSize: "40px", color: "red" }} />
  //           <div
  //             style={{ fontSize: "12px", fontWeight: "bold", color: "black" }}
  //           >
  //             P
  //           </div>
  //         </div>
  //       </Marker>

  //       {/* End Marker */}
  //       <Marker
  //         latitude={endLat}
  //         longitude={endLng}
  //         anchor="bottom"
  //         onClick={() => setSelectedLocation(end)}
  //       >
  //         <div style={{ textAlign: "center" }}>
  //           <EnvironmentFilled style={{ fontSize: "40px", color: "red" }} />
  //           <div
  //             style={{ fontSize: "12px", fontWeight: "bold", color: "black" }}
  //           >
  //             D
  //           </div>
  //         </div>
  //       </Marker>

  {
    /* Green Route Line */
  }
  //       {routeGeoJSON && (
  //         <Source id="green-route" type="geojson" data={routeGeoJSON}>
  //           <Layer
  //             id="green-line-layer"
  //             type="line"
  //             paint={{
  //               "line-color": "green",
  //               "line-width": 4,
  //             }}
  //           />
  //         </Source>
  //       )}
  //     </>
  //   );
  // };

  // Polyline and markers for all routePoints
  useEffect(() => {
    if (!Array.isArray(routePoints) || routePoints.length < 2) {
      setRouteGeoJSON(null);
      return;
    }
    // Build GeoJSON for a single polyline connecting all points in order
    const coordinates = routePoints.map((pt) => [
      parseFloat(pt.lng),
      parseFloat(pt.lat),
    ]);
    setRouteGeoJSON({
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates,
      },
    });
    // Center viewport on the average
    const avgLat =
      coordinates.reduce((sum, c) => sum + c[1], 0) / coordinates.length;
    const avgLng =
      coordinates.reduce((sum, c) => sum + c[0], 0) / coordinates.length;
    setViewport((prev) => ({
      ...prev,
      latitude: avgLat,
      longitude: avgLng,
      zoom: 10,
    }));
  }, [routePoints]);
  const renderGreenRouteAndYellowPins = () => {
    if (!Array.isArray(routePoints) || routePoints.length < 2) return null;
    return (
      <>
        {/* Markers for all points */}
        {routePoints.map((pt, idx) => {
          const lat = parseFloat(pt.lat);
          const lng = parseFloat(pt.lng);
          if (isNaN(lat) || isNaN(lng)) return null;
          let markerColor = "#ff4d4f"; // red for all
          let markerLabel = "D";
          if (idx === 0) {
            markerLabel = "P";
          }
          return (
            <Marker
              key={idx}
              latitude={lat}
              longitude={lng}
              anchor="bottom"
              onClick={() => setSelectedLocation(pt)}
            >
              <div style={{ textAlign: "center" }}>
                <EnvironmentFilled
                  style={{ fontSize: "32px", color: markerColor }}
                />
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  {markerLabel}
                </div>
              </div>
            </Marker>
          );
        })}
        {/* Polyline for all points */}
        {routeGeoJSON && (
          <Source id="green-route" type="geojson" data={routeGeoJSON}>
            <Layer
              id="green-line-layer"
              type="line"
              paint={{
                "line-color": "green",
                "line-width": 4,
              }}
            />
          </Source>
        )}
      </>
    );
  };
  useEffect(() => {
    if (routeDetails?.length > 0) {
      fetchRoute(routeDetails?.[0]);
    } else {
      setViewport({
        latitude: -1.286389, // Kenya
        longitude: 36.817223,
        zoom: 3,
        width: "100%",
        height: "100vh",
      });
    }
  }, [routeDetails]);
  useEffect(() => {
    if (Array.isArray(locationsTL) && locationsTL.length > 0) {
      const validLocations = locationsTL.filter((location) => {
        const lat = parseFloat(location.Lat);
        const lng = parseFloat(location.Lng);
        return (
          !isNaN(lat) &&
          !isNaN(lng) &&
          lat >= -90 &&
          lat <= 90 &&
          lng >= -180 &&
          lng <= 180
        );
      });

      if (validLocations.length > 0) {
        const avgLat =
          validLocations.reduce((sum, loc) => sum + parseFloat(loc.Lat), 0) /
          validLocations.length;
        const avgLng =
          validLocations.reduce((sum, loc) => sum + parseFloat(loc.Lng), 0) /
          validLocations.length;
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        const updateViewport = async () => {
          await delay(1000); // 1 second delay
          setViewport((prevViewport) => ({
            ...prevViewport,
            latitude: MapCoords ? avgLat / 2 : avgLat,
            longitude: MapCoords ? avgLng / 2 : avgLng,
            zoom: isminimap ? 20 : 10,
            height: isminimap ? "450px" : "100vh",
          }));
        };
        updateViewport();
        // Prepare GeoJSON line for red route
        const coordinates = validLocations.map((loc) => [
          parseFloat(loc.Lng),
          parseFloat(loc.Lat),
        ]);

        setLocationsRoute({
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates,
          },
        });
      }
    }
  }, [locationsTL, MapCoords, isminimap]);

  const validDriverPoints = (
    Array.isArray(locationsTLAI) ? locationsTLAI : []
  ).filter((ev) => !isNaN(parseFloat(ev.LAT)) && !isNaN(parseFloat(ev.LNG)));

  useEffect(() => {
    if (
      containerplanedRoutes?.Table?.length > 0 &&
      containerplanedRoutes.Table[0]?.FRoadPoints
    ) {
      const main = containerplanedRoutes.Table[0];

      let points = [];
      try {
        const parsed = JSON.parse(main.FRoadPoints);
        points = Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.error("Failed to parse FRoadPoints:", e);
      }

      if (points.length === 0) return;

      const coordinates = points.map((pt) => [pt.lng, pt.lat]);

      setPlannedContainerRoute({
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates,
        },
      });

      // optionally set center viewport
      const centerLat = (main.FStartCenterLat + main.FEndCenterLat) / 2;
      const centerLng = (main.FStartCenterLon + main.FEndCenterLon) / 2;
      setViewport((prev) => ({
        ...prev,
        latitude: centerLat,
        longitude: centerLng,
        zoom: 12,
      }));
    }
  }, [containerplanedRoutes]);

  const getDriverRouteGeoJSON = async (points) => {
    const accessToken =
      "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";
    let fullCoordinates = [];

    for (let i = 0; i < points.length - 1; i++) {
      const start = points[i];
      const end = points[i + 1];
      const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${start.LNG},${start.LAT};${end.LNG},${end.LAT}?geometries=geojson&access_token=${accessToken}`;

      const res = await fetch(url);
      const data = await res.json();
      const coords = data.routes?.[0]?.geometry?.coordinates;

      if (Array.isArray(coords)) {
        fullCoordinates.push(...coords);
      }
    }

    return {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: fullCoordinates,
      },
    };
  };

  useEffect(() => {
    const fetchDriverRoute = async () => {
      const points = (Array.isArray(locationsTLAI) ? locationsTLAI : []).filter(
        (ev) => !isNaN(parseFloat(ev.LAT)) && !isNaN(parseFloat(ev.LNG))
      );
      if (points?.length >= 2) {
        const geoJson = await getDriverRouteGeoJSON(points);
        setDriverRouteGeoJSON(geoJson);
      }
    };

    fetchDriverRoute();
  }, [locationsTLAI]);

  const getActualDrivingRoute = async (startLat, startLng, endLat, endLng) => {
    const accessToken =
      "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";
    const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${startLng},${startLat};${endLng},${endLat}?geometries=geojson&access_token=${accessToken}`;

    const res = await fetch(url);
    const data = await res.json();

    const coordinates = data.routes?.[0]?.geometry?.coordinates;

    if (coordinates && coordinates.length > 0) {
      return {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates,
        },
      };
    }

    return null;
  };

  function getActualRouteViewport(actualLocationsAI) {
    if (!actualLocationsAI?.length) return null;

    // Collect all relevant coordinates (Start + End + intermediate points if any)
    const coords = actualLocationsAI
      .flatMap((loc) => [
        [parseFloat(loc.StartLat), parseFloat(loc.StartLng)],
        [parseFloat(loc.EndLat), parseFloat(loc.EndLng)],
      ])
      .filter(([lat, lng]) => !isNaN(lat) && !isNaN(lng));

    if (!coords.length) return null;

    const lats = coords.map(([lat]) => lat);
    const lngs = coords.map(([, lng]) => lng);

    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
    const minLng = Math.min(...lngs);
    const maxLng = Math.max(...lngs);

    // Center point
    const latitude = (minLat + maxLat) / 2;
    const longitude = (minLng + maxLng) / 2;

    // Approximate zoom based on bounding box span
    const latDiff = maxLat - minLat;
    const lngDiff = maxLng - minLng;
    const maxDiff = Math.max(latDiff, lngDiff);

    //  Dynamic zoom — adjust constants as needed
    const zoom =
      maxDiff < 0.01
        ? 8
        : maxDiff < 0.05
        ? 8
        : maxDiff < 0.1
        ? 10
        : maxDiff < 0.5
        ? 10
        : maxDiff < 1
        ? 7
        : 8;

    return {
      latitude,
      longitude,
      zoom,
      width: "100%",
      height: "130vh",
    };
  }

  useEffect(() => {
    const fetchRoute = async () => {
      if (!actualLocationsAI?.length) return;

      const { StartLat, StartLng, EndLat, EndLng } = actualLocationsAI[0];
      const startLat = parseFloat(StartLat);
      const startLng = parseFloat(StartLng);
      const endLat = parseFloat(EndLat);
      const endLng = parseFloat(EndLng);

      if (isNaN(startLat) || isNaN(startLng) || isNaN(endLat) || isNaN(endLng))
        return;

      const route = await getActualDrivingRoute(
        startLat,
        startLng,
        endLat,
        endLng
      );

      if (route) {
        setRouteGeoJSON(route);

        const newViewport = getActualRouteViewport(actualLocationsAI);
        if (newViewport) setViewport((prev) => ({ ...prev, ...newViewport }));
      }
    };

    fetchRoute();
  }, [actualLocationsAI]);

  useEffect(() => {
    if (Array.isArray(tripEvent) && tripEvent.length > 0) {
      const validLocations = tripEvent.filter((location) => {
        const lat = parseFloat(location.Lat) || "-1.3847331";
        const lng = parseFloat(location.Lng) || "36.9388587";
        return (
          !isNaN(lat) &&
          !isNaN(lng) &&
          lat >= -90 &&
          lat <= 90 &&
          lng >= -180 &&
          lng <= 180
        );
      });

      if (validLocations.length > 0) {
        const avgLat =
          validLocations.reduce((sum, loc) => sum + parseFloat(loc.Lat), 0) /
          validLocations.length;
        const avgLng =
          validLocations.reduce((sum, loc) => sum + parseFloat(loc.Lng), 0) /
          validLocations.length;

        setViewport((prevViewport) => ({
          ...prevViewport,
          latitude: avgLat,
          longitude: avgLng,
          zoom: isminimap ? 20 : 10,
          height: isminimap ? "450px" : "100vh",
        }));

        // Prepare GeoJSON line for red route
        const coordinates = validLocations.map((loc) => [
          parseFloat(loc.Lng),
          parseFloat(loc.Lat),
        ]);

        setLocationsRoute({
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates,
          },
        });
      }
    }
  }, [tripEvent]);

  // Existing rendering logic for locationsTL remains unchanged

  const fetchRoute = async (location) => {
    const { StartLng, StartLat, EndLng, EndLat } = location;

    const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${StartLng},${StartLat};${EndLng},${EndLat}?geometries=geojson&access_token=${MAPBOX_TOKEN}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data.routes && data.routes.length > 0) {
        setRouteGeoJSON({
          type: "Feature",
          geometry: data.routes[0].geometry,
        });
        setViewport({
          width: "100%",
          height: "100vh",
          longitude:
            (Number(location?.StartLng) + Number(location?.EndLng)) / 2,
          latitude: (Number(location?.StartLat) + Number(location?.EndLat)) / 2,
          zoom: 10,
        });
      } else {
        console.error("No route found!");
      }
    } catch (error) {
      console.error("Error fetching route:", error);
    }
  };

  const fetchLocation = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow`
      );
      const data = await response.json();

      return data?.features?.[0]?.place_name || "Unknown Location";
    } catch (error) {
      console.error("Error fetching location:", error);
      return "Unknown Location";
    }
  };
  // (async () => {
  //   let fetchfunction = await fetchLocation(locationsTLAI[0]?.LAT, locationsTLAI[0]?.LNG);
  //   setLocationsRoute()
  // })();
  useEffect(() => {
    const getLocation = async () => {
      const locationName = await fetchLocation(
        locationsTLAI[0]?.LAT,
        locationsTLAI[0]?.LNG
      );
      setTriptracklinklocation(locationName);
    };
    getLocation();
  }, []);

  useEffect(() => {
    const getLocationAI = async () => {
      const locationNameAI = await fetchLocation(
        locationsTLAI[0]?.Lat,
        locationsTLAI[0]?.Lng
      );
      setTriptracklinklocationAI(locationNameAI);
    };
    getLocationAI();
  }, []);

  const [mapLocationName, setMapLocationName] = useState("Loading...");

  useEffect(() => {
    const getLocationName = async () => {
      if (containerDetailMap?.FLatitude && containerDetailMap?.FLongitude) {
        const location = await fetchLocation(
          containerDetailMap.FLatitude,
          containerDetailMap.FLongitude
        );
        setMapLocationName(location);
      } else {
        setMapLocationName("Unknown Location");
      }
    };

    getLocationName();
  }, [containerDetailMap]);

  const lineGeoJSON = {
    type: "Feature",
    geometry: {
      type: "LineString",
      coordinates: [
        [
          parseFloat(pinlocation?.[0]?.StartLng),
          parseFloat(pinlocation?.[0]?.StartLat),
        ],
        [
          parseFloat(pinlocation?.[0]?.EndLng),
          parseFloat(pinlocation?.[0]?.EndLat),
        ],
      ],
    },
  };

  useEffect(() => {
    if (containerDetailMap?.FLatitude && containerDetailMap?.FLongitude) {
      setViewport((prev) => ({
        ...prev,
        latitude: Number(containerDetailMap.FLatitude),
        longitude: Number(containerDetailMap.FLongitude),
        zoom: 15,
        height: "757px",
      }));
    }
  }, [containerDetailMap]);

  // GEO FENCE MANAGEMENT MAP

  // Polygon state
  const [polygonPoints, setPolygonPoints] = useState([]);
  const [isDrawingPolygon, setIsDrawingPolygon] = useState(false);
  const [previewPoint, setPreviewPoint] = useState(null);
  const [isPolygonComplete, setIsPolygonComplete] = useState(false);
  const [isSnapping, setIsSnapping] = useState(false);
  const mapRef = useRef();
  const [searchValue, setSearchValue] = useState("");
  // Reset helper
  const resetPolygon = () => {
    setPolygonPoints([]);
    setIsDrawingPolygon(false);
    setPreviewPoint(null);
    setIsPolygonComplete(false);
    setIsSnapping(false);
  };

  // Load polygon when initialPolygon is provided
  useEffect(() => {
    if (initialPolygon && initialPolygon.length > 0) {
      const closed = [...initialPolygon, initialPolygon[0]];
      setPolygonPoints(closed);
      setIsPolygonComplete(true);

      // Create turf polygon
      const turfPolygon = turf.polygon([closed.map((p) => [p.lng, p.lat])]);

      // Get bounding box [minX, minY, maxX, maxY]
      const bbox = turf.bbox(turfPolygon);

      // Use WebMercatorViewport to fit bounds
      const viewport = new WebMercatorViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      }).fitBounds(
        [
          [bbox[0], bbox[1]],
          [bbox[2], bbox[3]],
        ],
        { padding: 20 } // add padding so polygon isn’t at the edge
      );

      setViewport((prev) => ({
        ...prev,
        latitude: viewport.latitude,
        longitude: viewport.longitude,
        zoom: 18,
        height: "1120px",
        transitionDuration: 1000, // smooth zoom
      }));
    }
  }, [initialPolygon]);

  const handleMapClick = (event) => {
    if (!isEditing) return;
    if (drawingMode === "polygon" && isEditing) {
      const [lng, lat] = event.lngLat;

      if (!isDrawingPolygon) {
        setPolygonPoints([{ lat, lng }]);
        setIsDrawingPolygon(true);
      } else {
        if (polygonPoints.length > 2 && isSnapping) {
          finishPolygon();
          return;
        }

        setPolygonPoints((prev) => [...prev, { lat, lng }]);
      }
    }
  };

  const SNAP_DISTANCE = 0.002; // ~200m (tweak as needed)

  const handleMapMouseMove = (event) => {
    if (drawingMode === "polygon" && isDrawingPolygon) {
      const [lng, lat] = event.lngLat;
      setPreviewPoint({ lat, lng });

      if (polygonPoints.length > 0) {
        const first = polygonPoints[0];
        const dist = Math.sqrt(
          Math.pow(first.lat - lat, 2) + Math.pow(first.lng - lng, 2)
        );

        setIsSnapping(dist < SNAP_DISTANCE);
      }
    }
  };

  const handleMapDoubleClick = (event) => {
    event.preventDefault(); // stop zoom
    return false;
  };

  const finishPolygon = () => {
    const closedPoints = [...polygonPoints, polygonPoints[0]];
    setPolygonPoints(closedPoints);
    setPreviewPoint(null);
    setIsDrawingPolygon(false);
    setIsPolygonComplete(true);

    if (typeof onPolygonDraw === "function") {
      onPolygonDraw(closedPoints);
    }
  };
  useEffect(() => {
    if (resetTrigger) {
      resetPolygon(); // your existing helper
    }
  }, [resetTrigger]);

  // ROUTE MANAGEMENT
  // Helper to safely parse JSON arrays

  const isFenceArray = Array.isArray(routeData);
  useEffect(() => {
    if (isFenceArray && routeData.length > 0) {
      // Collect all fence polygon points
      let allPoints = [];
      routeData.forEach((fence) => {
        let path = [];
        try {
          path = JSON.parse(fence.FPath || "[]");
        } catch {
          path = [];
        }
        allPoints.push(...path);
      });
      // If no points, fallback to centers
      if (allPoints.length === 0) {
        allPoints = routeData.map((f) => ({
          lat: Number(f.FCenterLat),
          lng: Number(f.FCenterLon),
        }));
      }
      // Calculate bounds/center
      if (allPoints.length > 0) {
        const lats = allPoints
          .map((p) => Number(p.lat))
          .filter((v) => !isNaN(v));
        const lngs = allPoints
          .map((p) => Number(p.lng))
          .filter((v) => !isNaN(v));
        const minLat = Math.min(...lats);
        const maxLat = Math.max(...lats);
        const minLng = Math.min(...lngs);
        const maxLng = Math.max(...lngs);
        const centerLat = (minLat + maxLat) / 2;
        const centerLng = (minLng + maxLng) / 2;
        setViewport((v) => ({
          ...v,
          latitude: centerLat,
          longitude: centerLng,
          zoom: routeData.length === 1 ? 10 : 7, // zoom in for single, out for multiple
        }));
      }
    }
    // Only run when fences change
  }, [isFenceArray, routeData]);
  const safeParseArray = (str) => {
    try {
      const arr = JSON.parse(str || "[]");
      return Array.isArray(arr) ? arr : [];
    } catch {
      return [];
    }
  };

  const isValidLatLng = (lat, lng) =>
    typeof lat === "number" &&
    typeof lng === "number" &&
    !isNaN(lat) &&
    !isNaN(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180;

  // Only for routeData mode
  const roadPoints = safeParseArray(routeData?.FRoadPoints);
  const startPath = safeParseArray(routeData?.FStartPath);
  const endPath = safeParseArray(routeData?.FEndPath);

  const startLat = Number(routeData?.FStartCenterLat);
  const startLng = Number(routeData?.FStartCenterLon);
  const endLat = Number(routeData?.FEndCenterLat);
  const endLng = Number(routeData?.FEndCenterLon);
  const getBounds = () => {
    const allPoints = [
      ...roadPoints.map((p) => [p.lng, p.lat]),
      [startLng, startLat],
      [endLng, endLat],
    ].filter(([lng, lat]) => isValidLatLng(lat, lng));

    if (allPoints.length === 0) return null;

    const lats = allPoints.map(([lng, lat]) => lat);
    const lngs = allPoints.map(([lng, lat]) => lng);

    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
    const minLng = Math.min(...lngs);
    const maxLng = Math.max(...lngs);

    return {
      bounds: [
        [minLng, minLat],
        [maxLng, maxLat],
      ],
      center: [(minLat + maxLat) / 2, (minLng + maxLng) / 2],
    };
  };
  useEffect(() => {
    const result = getBounds();
    if (result) {
      const { center } = result;
      setViewport({
        latitude: center[0],
        longitude: center[1],
        zoom: mapSize === "large" ? 12 : 14, // you may adjust or calculate zoom based on extent
      });
    }
  }, [routeData]);

  const centerLat = roadPoints.length
    ? roadPoints.reduce((sum, p) => sum + Number(p.lat), 0) / roadPoints.length
    : (startLat + endLat) / 2;
  const centerLng = roadPoints.length
    ? roadPoints.reduce((sum, p) => sum + Number(p.lng), 0) / roadPoints.length
    : (startLng + endLng) / 2;
  const hasValidCenter =
    isValidLatLng(centerLat, centerLng) &&
    (roadPoints.length > 0 ||
      (isValidLatLng(startLat, startLng) && isValidLatLng(endLat, endLng)));

  function getFormattedDateTime(noww) {
    const now = noww ? new Date(noww) : new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(now.getDate()).padStart(2, "0");

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
  return (
    <>
      <div className="container_formapp">
        {showSearch && (
          <SearchBox
            accessToken={MAPBOX_TOKEN}
            value={searchValue}
            onChange={setSearchValue}
            onRetrieve={(result) => {
              // result.features[0].geometry.coordinates = [lng, lat]
              const coords = result.features?.[0]?.geometry?.coordinates;
              if (coords) {
                setViewport((prev) => ({
                  ...prev,
                  longitude: coords[0],
                  latitude: coords[1],
                  zoom: 15,
                }));
              }
            }}
            marker={false} // Don't let SearchBox try to add a marker
            theme="light"
            style={{
              position: "absolute",
              top: 20,
              left: 20,
              zIndex: 100,
              width: 350,
              maxWidth: "90vw",
            }}
          />
        )}
        {(isFenceArray || hasValidCenter) && routeData ? (
          <InteractiveMap
            {...viewport}
            onViewportChange={(newViewport) => setViewport(newViewport)}
            width={mapWidth}
            height={mapHeight}
            mapStyle={
              isSatellite
                ? "mapbox://styles/mapbox/satellite-streets-v11"
                : "mapbox://styles/mapbox/streets-v11"
            }
            mapboxApiAccessToken={MAPBOX_TOKEN}
            scrollZoom={true} // Enables scrolling
            dragPan={true} // Allows dragging
            doubleClickZoom={true}
            touchZoom={true}
            attributionControl={true}
          >
            {isFenceArray &&
              routeData.map((fence) => {
                const idx = fence.FGUID;
                let path = [];
                try {
                  path = JSON.parse(fence.FPath || "[]");
                } catch {
                  path = [];
                }
                // Filter out invalid points
                path = path.filter(
                  (p) =>
                    typeof p.lat === "number" &&
                    typeof p.lng === "number" &&
                    !isNaN(p.lat) &&
                    !isNaN(p.lng)
                );
                if (path.length < 3) return null; // Don't render invalid polygons

                const lat = Number(fence.FCenterLat);
                const lng = Number(fence.FCenterLon);
                return (
                  <React.Fragment key={fence.FGUID}>
                    {/* Polygon */}
                    <Source
                      id={`fence-polygon-${idx}`}
                      type="geojson"
                      data={{
                        type: "Feature",
                        geometry: {
                          type: "Polygon",
                          coordinates: [
                            [
                              ...path.map((p) => [p.lng, p.lat]),
                              [path[0].lng, path[0].lat],
                            ],
                          ],
                        },
                      }}
                    >
                      <Layer
                        id={`fence-fill-${idx}`}
                        type="fill"
                        paint={{
                          "fill-color": "#06CE06",
                          "fill-opacity": 0.3,
                        }}
                      />
                      <Layer
                        id={`fence-outline-${idx}`}
                        type="line"
                        paint={{
                          "line-color": "#06CE06",
                          "line-width": 2,
                        }}
                      />
                    </Source>
                    {/* Center Marker */}
                    {lat && lng && (
                      <Marker latitude={lat} longitude={lng} anchor="center">
                        <div
                          style={{
                            width: 16,
                            height: 16,
                            background: "#06CE06",
                            borderRadius: "50%",
                            border: "2px solid #fff",
                            boxShadow: "0 0 4px #06CE06",
                          }}
                          title={fence.FName}
                        />
                      </Marker>
                    )}
                  </React.Fragment>
                );
              })}
            {rGeoJSON && (
              <Source
                id="edit-green-route"
                type="geojson"
                data={{ type: "Feature", geometry: rGeoJSON }}
              >
                <Layer
                  id="edit-green-route-line"
                  type="line"
                  paint={{
                    "line-color": "#06CE06",
                    "line-width": 6,
                    "line-opacity": 1,
                  }}
                />
              </Source>
            )}
            {/* Green Route Line */}
            {roadPoints.length > 1 && (
              <Source
                id="route-line"
                type="geojson"
                data={{
                  type: "Feature",
                  geometry: {
                    type: "LineString",
                    coordinates: roadPoints.map((p) => [p.lng, p.lat]),
                  },
                }}
              >
                <Layer
                  id="route-line-layer"
                  type="line"
                  paint={{
                    "line-color": "#06CE06",
                    "line-width": 6,
                    "line-opacity": 1,
                  }}
                />
              </Source>
            )}
            {/* {routeGeoJSON && (
  <Source id="driving-route" type="geojson" data={routeGeoJSON}>
    <Layer
      id="driving-line"
      type="line"
      layout={{
        "line-cap": "round",
        "line-join": "round",
      }}
      paint={{
        "line-color": "#06CE06", // green (match above if you want)
        "line-width": 4,
        "line-opacity": 0.8,
      }}
    />
    <Layer
      id="driving-route"
      type="symbol"
      layout={{
        "symbol-placement": "line",
        "text-field": "<",
        "text-size": 16,
        "symbol-spacing": 40,
        "text-rotation-alignment": "map",
        "text-keep-upright": true,
      }}
      paint={{
        "text-color": "#ffffff",
      }}
    />
  </Source>
)} */}
            {/* Start Rectangle */}
            {startPath.length > 2 && (
              <Source
                className="container_formap_component"
                id="start-rect"
                type="geojson"
                data={{
                  type: "Feature",
                  geometry: {
                    type: "Polygon",
                    coordinates: [
                      [
                        ...startPath.map((p) => [p.lng, p.lat]),
                        [startPath[0].lng, startPath[0].lat],
                      ],
                    ],
                  },
                }}
              >
                <Layer
                  id="start-rect-fill"
                  type="fill"
                  paint={{
                    "fill-color": "#06CE06",
                    "fill-opacity": 0.3,
                  }}
                />
                <Layer
                  id="start-rect-outline"
                  type="line"
                  paint={{
                    "line-color": "#06CE06",
                    "line-width": 2,
                  }}
                />
              </Source>
            )}

            {/* End Rectangle */}
            {endPath.length > 2 && (
              <Source
                id="end-rect"
                type="geojson"
                data={{
                  type: "Feature",
                  geometry: {
                    type: "Polygon",
                    coordinates: [
                      [
                        ...endPath.map((p) => [p.lng, p.lat]),
                        [endPath[0].lng, endPath[0].lat],
                      ],
                    ],
                  },
                }}
              >
                <Layer
                  id="end-rect-fill"
                  type="fill"
                  paint={{
                    "fill-color": "#06CE06",
                    "fill-opacity": 0.3,
                  }}
                />
                <Layer
                  id="end-rect-outline"
                  type="line"
                  paint={{
                    "line-color": "#06CE06",
                    "line-width": 2,
                  }}
                />
              </Source>
            )}

            {/* Start Marker with label */}
            {isValidLatLng(startLat, startLng) && (
              <Marker latitude={startLat} longitude={startLng} anchor="bottom">
                <div style={{ textAlign: "center" }}>
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      background: "#06CE06",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                      boxShadow: "0 0 4px #06CE06",
                      margin: "0 auto",
                    }}
                  />
                  <div
                    style={{
                      background: "white",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                      marginTop: "4px",
                      fontSize: "12px",
                      color: "#333",
                      maxWidth: "150px",
                      wordBreak: "break-word",
                    }}
                  >
                    {routeData?.FStartFenceName}
                  </div>
                </div>
              </Marker>
            )}

            {/* End Marker with label */}
            {isValidLatLng(endLat, endLng) && (
              <Marker latitude={endLat} longitude={endLng} anchor="bottom">
                <div style={{ textAlign: "center" }}>
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      background: "#06CE06",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                      boxShadow: "0 0 4px #06CE06",
                      margin: "0 auto",
                    }}
                  />
                  <div
                    style={{
                      background: "white",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                      marginTop: "4px",
                      fontSize: "12px",
                      color: "#333",
                      maxWidth: "150px",
                      wordBreak: "break-word",
                    }}
                  >
                    {routeData?.FEndFenceName}
                  </div>
                </div>
              </Marker>
            )}
          </InteractiveMap>
        ) : (
          <InteractiveMap
            ref={mapRef}
            {...viewport}
            onViewportChange={(newViewport) => setViewport(newViewport)}
            mapStyle={
              isSatellite
                ? "mapbox://styles/mapbox/satellite-streets-v11"
                : "mapbox://styles/mapbox/streets-v11"
            }
            mapboxApiAccessToken={
              "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow"
            }
            scrollZoom={true} // Enables scrolling
            dragPan={true} // Allows dragging
            touchZoom={true} // Enables touch gestures
            onClick={handleMapClick}
            onDblClick={handleMapDoubleClick}
            onMouseMove={handleMapMouseMove}
            doubleClickZoom={false}
          >
            {/* GEO FENCE MAP */}
            {/* First point marker */}
            {/* {polygonPoints.length > 0 && (
                  <Marker
                    latitude={polygonPoints[0].lat}
                    longitude={polygonPoints[0].lng}
                  >
                    <div
                      style={{
                        width: 14,
                        height: 14,
                        background: "#06CE06",
                        border: "2px solid white",
                        borderRadius: "50%",
                        cursor: "pointer",
                      }}
                    />
                  </Marker>
                )} */}
            {/* Green Route Line */}
            {roadPoints.length > 1 && (
              <Source
                id="route-line"
                type="geojson"
                data={{
                  type: "Feature",
                  geometry: {
                    type: "LineString",
                    coordinates: roadPoints.map((p) => [p.lng, p.lat]),
                  },
                }}
              >
                <Layer
                  id="route-line-layer"
                  type="line"
                  paint={{
                    "line-color": "#06CE06",
                    "line-width": 6,
                    "line-opacity": 1,
                  }}
                />
              </Source>
            )}

            {/* Start Rectangle */}
            {startPath.length > 2 && (
              <Source
                id="start-rect"
                type="geojson"
                data={{
                  type: "Feature",
                  geometry: {
                    type: "Polygon",
                    coordinates: [
                      [
                        ...startPath.map((p) => [p.lng, p.lat]),
                        [startPath[0].lng, startPath[0].lat],
                      ],
                    ],
                  },
                }}
              >
                <Layer
                  id="start-rect-fill"
                  type="fill"
                  paint={{
                    "fill-color": "#06CE06",
                    "fill-opacity": 0.3,
                  }}
                />
                <Layer
                  id="start-rect-outline"
                  type="line"
                  paint={{
                    "line-color": "#06CE06",
                    "line-width": 2,
                  }}
                />
              </Source>
            )}

            {/* End Rectangle */}
            {endPath.length > 2 && (
              <Source
                id="end-rect"
                type="geojson"
                data={{
                  type: "Feature",
                  geometry: {
                    type: "Polygon",
                    coordinates: [
                      [
                        ...endPath.map((p) => [p.lng, p.lat]),
                        [endPath[0].lng, endPath[0].lat],
                      ],
                    ],
                  },
                }}
              >
                <Layer
                  id="end-rect-fill"
                  type="fill"
                  paint={{
                    "fill-color": "#06CE06",
                    "fill-opacity": 0.3,
                  }}
                />
                <Layer
                  id="end-rect-outline"
                  type="line"
                  paint={{
                    "line-color": "#06CE06",
                    "line-width": 2,
                  }}
                />
              </Source>
            )}

            {/* Start Marker (green dot) */}
            {isValidLatLng(startLat, startLng) && (
              <Marker latitude={startLat} longitude={startLng} anchor="center">
                <div
                  style={{
                    width: 18,
                    height: 18,
                    background: "#06CE06",
                    borderRadius: "50%",
                    border: "2px solid #fff",
                    boxShadow: "0 0 4px #06CE06",
                  }}
                />
              </Marker>
            )}
            {/* Final polygon after completion */}
            {isPolygonComplete && polygonPoints.length > 2 && (
              <Source
                id="polygon"
                type="geojson"
                data={{
                  type: "Feature",
                  geometry: {
                    type: "Polygon",
                    coordinates: [
                      [
                        ...polygonPoints.map((p) => [p.lng, p.lat]),
                        [polygonPoints[0].lng, polygonPoints[0].lat], // close polygon
                      ],
                    ],
                  },
                }}
              >
                <Layer
                  id="polygon-fill"
                  type="fill"
                  paint={{
                    "fill-color": isEditing ? "#06CE06" : "#06CE06", // light green in view
                    "fill-opacity": 0.3,
                  }}
                />
                <Layer
                  id="polygon-outline"
                  type="line"
                  paint={{
                    "line-color": isEditing ? "#06CE06" : "#06CE06", // light green in view
                    "line-width": 2,
                    // "line-dasharray": !isEditing ? [2, 2] : [0, 0], // dotted in view mode
                  }}
                />
              </Source>
            )}

            {/* In-progress preview line */}
            {isDrawingPolygon && polygonPoints.length > 0 && previewPoint && (
              <Source
                id="polygon-preview"
                type="geojson"
                data={{
                  type: "Feature",
                  geometry: {
                    type: "LineString",
                    coordinates: [
                      ...polygonPoints.map((p) => [p.lng, p.lat]),
                      [previewPoint.lng, previewPoint.lat], // live preview
                    ],
                  },
                }}
              >
                <Layer
                  id="preview-line"
                  type="line"
                  paint={{
                    "line-color": "black",
                    "line-width": 2,
                    "line-dasharray": [2, 4],
                  }}
                />
              </Source>
            )}

            {/* Snap circle when near starting point */}
            {isDrawingPolygon && isSnapping && polygonPoints.length > 0 && (
              <Source
                id="snap-circle"
                type="geojson"
                data={{
                  type: "Feature",
                  geometry: {
                    type: "Point",
                    coordinates: [polygonPoints[0].lng, polygonPoints[0].lat],
                  },
                }}
              >
                <Layer
                  id="snap-circle-layer"
                  type="circle"
                  paint={{
                    "circle-radius": 8,
                    "circle-color": "red", // green highlight
                    "circle-stroke-width": 2,
                    "circle-stroke-color": "#fff",
                  }}
                />
              </Source>
            )}

            {/* ✅ Planned container green route */}
            {plannedContainerRoute && (
              <Source
                id="container-planned-route"
                type="geojson"
                data={plannedContainerRoute}
              >
                <Layer
                  id="container-planned-line"
                  type="line"
                  layout={{
                    "line-cap": "round",
                    "line-join": "round",
                  }}
                  paint={{
                    "line-color": "#006400", // dark green
                    "line-width": 8,
                  }}
                />
                <Layer
                  id="container-planned-arrows"
                  type="symbol"
                  layout={{
                    "symbol-placement": "line",
                    "text-field": "<", // arrow symbol
                    "text-size": 18,
                    "symbol-spacing": 40,
                    "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"], // ensure it's bold
                    "text-rotation-alignment": "map",
                    "text-keep-upright": true,
                  }}
                  paint={{
                    "text-color": "#ffffff",
                  }}
                />
              </Source>
            )}

            {/* ✅ From & To Red Pins for container */}
            {containerplanedRoutes?.Table?.length > 0 &&
              (() => {
                const {
                  FStartCenterLat,
                  FStartCenterLon,
                  FEndCenterLat,
                  FEndCenterLon,
                } = containerplanedRoutes.Table[0];

                return (
                  <>
                    {/* From Marker */}
                    {FStartCenterLat && FStartCenterLon && (
                      <Marker
                        latitude={FStartCenterLat}
                        longitude={FStartCenterLon}
                        anchor="bottom"
                      >
                        <div style={{ textAlign: "center" }}>
                          <div style={{ fontSize: "22px", color: "red" }}>
                            📍
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              background: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              padding: "1px 4px",
                              marginTop: "2px",
                              fontWeight: "bold",
                            }}
                          >
                            From
                          </div>
                        </div>
                      </Marker>
                    )}
                    {/* To Marker */}
                    {FEndCenterLat && FEndCenterLon && (
                      <Marker
                        latitude={FEndCenterLat}
                        longitude={FEndCenterLon}
                        anchor="bottom"
                      >
                        <div style={{ textAlign: "center" }}>
                          <div style={{ fontSize: "22px", color: "red" }}>
                            📍
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              background: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              padding: "1px 4px",
                              marginTop: "2px",
                              fontWeight: "bold",
                            }}
                          >
                            To
                          </div>
                        </div>
                      </Marker>
                    )}
                  </>
                );
              })()}

            {Array.isArray(locationsTLAI) && locationsTLAI.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: 5,
                  right: 5,
                  background: "#fff",
                  padding: "5px 10px",
                  borderRadius: "8px",
                  boxShadow: "0 0 6px rgba(0,0,0,0.15)",
                  zIndex: 10,
                  fontFamily: "sans-serif",
                  minWidth: "160px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "3px",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <RouteIcons /> <p style={{ marginBottom: "0px" }}>All</p>
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "3px",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Rectangle />{" "}
                    <p style={{ marginBottom: "0px" }}>Route plan</p>
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "3px",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Routeused />{" "}
                    <p style={{ marginBottom: "0px" }}>Route Used</p>
                  </span>
                </div>

                {/* Toggle Button */}
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    onClick={() => setShowActualRoute((prev) => !prev)}
                    style={{
                      backgroundColor: showActualRoute ? "#007bff" : "#fff", // Blue if showing, white if hidden
                      border: "1px solid #ccc",
                      padding: "8px 10px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      // display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 0 4px rgba(0,0,0,0.15)",
                      display: "none",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "18px",
                        color: showActualRoute ? "#fff" : "#555", // White if showing, grey if hidden
                        fontWeight: "bold",
                      }}
                    >
                      ↔
                    </span>
                  </button>
                </div>
              </div>
            )}
            <Newbox>
              {Array.isArray(locationsTLAI) && locationsTLAI.length > 0 && (
                <>
                  <div
                    className="map_satellite_toggle"
                    // style={{
                    //   position: "absolute",
                    //   bottom: 20,
                    //   right: 20,
                    //   zIndex: 10,
                    //   display: "flex",
                    //   gap:20,
                    // }}
                  >
                    {/* Reset button */}
                    <button
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        border: "none",
                        background: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      }}
                      title="Reset Map"
                      onClick={() => {
                        const v = getActualRouteViewport(actualLocationsAI);
                        if (v) setViewport(v);
                        else setViewport(defaultViewport);
                      }}
                    >
                      {/* SVG icon */}
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <circle
                          cx="11"
                          cy="11"
                          r="4"
                          stroke="#222"
                          strokeWidth="2"
                        />
                        <circle cx="11" cy="11" r="1.5" fill="#222" />
                        <line
                          x1="11"
                          y1="2"
                          x2="11"
                          y2="5"
                          stroke="#222"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <line
                          x1="11"
                          y1="17"
                          x2="11"
                          y2="20"
                          stroke="#222"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <line
                          x1="2"
                          y1="11"
                          x2="5"
                          y2="11"
                          stroke="#222"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <line
                          x1="17"
                          y1="11"
                          x2="20"
                          y2="11"
                          stroke="#222"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </button>

                    {/* Map/Satellite toggle */}
                    <div
                      className="map_container_toggling"
                      style={{
                        display: "flex",
                        borderRadius: "8px",
                        overflow: "hidden",
                        border: "1px solid #ccc",
                        background: "#fff",
                        width: "100%",
                      }}
                    >
                      <button
                        onClick={() => setIsSatellite(false)}
                        style={{
                          padding: "3px 29px",
                          border: "none",
                          background: !isSatellite ? "#f0f0f0" : "#fff",
                          cursor: "pointer",
                        }}
                      >
                        Map
                      </button>
                      <button
                        onClick={() => setIsSatellite(true)}
                        style={{
                          padding: "3px 29px",
                          border: "none",
                          background: isSatellite ? "#fff" : "#fff",
                          cursor: "pointer",
                        }}
                      >
                        Satellite
                      </button>
                    </div>
                  </div>

                  {/* Satellite View Toggle Button */}
                </>
              )}
            </Newbox>

            {/* ✅ Green driving route line */}
            {routeGeoJSON && (
              <Source id="driving-route" type="geojson" data={routeGeoJSON}>
                <Layer
                  id="driving-line"
                  type="line"
                  layout={{
                    "line-cap": "round",
                    "line-join": "round",
                  }}
                  paint={{
                    "line-color": "#008000", // dark green

                    "line-width": 8,
                  }}
                />
                <Layer
                  id="driving-route"
                  type="symbol"
                  layout={{
                    "symbol-placement": "line",
                    "text-field": "<",
                    "text-size": 16,
                    "symbol-spacing": 40,
                    "text-rotation-alignment": "map",
                    "text-keep-upright": true,
                  }}
                  paint={{
                    "text-color": "#ffffff",
                  }}
                />
              </Source>
            )}

            {/* ✅ From and To red pin markers */}
            {/* {actualLocationsAI?.length > 0 &&
              (() => {
                const { StartLat, StartLng, EndLat, EndLng } =
                  actualLocationsAI[0];
                const startLat = parseFloat(StartLat);
                const startLng = parseFloat(StartLng);
                const endLat = parseFloat(EndLat);
                const endLng = parseFloat(EndLng);

                if (
                  isNaN(startLat) ||
                  isNaN(startLng) ||
                  isNaN(endLat) ||
                  isNaN(endLng)
                )
                  return null;

                return (
                  <> */}
            {/* From Marker */}
            {/* <Marker
                      latitude={startLat}
                      longitude={startLng}
                      anchor="bottom"
                    >
                      <div style={{ textAlign: "center" }}>
                        <div
                          style={{
                            fontSize: "22px",
                            color: "red",
                            lineHeight: 1,
                          }}
                        >
                          📍
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            background: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "1px 4px",
                            marginTop: "2px",
                            fontWeight: "bold",
                          }}
                        >
                          From
                        </div>
                      </div>
                    </Marker> */}

            {/* To Marker */}
            {/* <Marker
                      latitude={endLat}
                      longitude={endLng}
                      anchor="bottom"
                    >
                      <div style={{ textAlign: "center" }}>
                        <div
                          style={{
                            fontSize: "22px",
                            color: "red",
                            lineHeight: 1,
                          }}
                        >
                          📍
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            background: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "1px 4px",
                            marginTop: "2px",
                            fontWeight: "bold",
                          }}
                        >
                          To
                        </div>
                      </div>
                    </Marker>
                  </>
                );
              })()} */}

            {/* 🔵 Blue line - actual route taken by driver */}
            {showActualRoute && driverRouteGeoJSON && (
              <Source
                id="driver-route"
                type="geojson"
                data={driverRouteGeoJSON}
              >
                <Layer
                  id="driver-line"
                  type="line"
                  layout={{ "line-cap": "round", "line-join": "round" }}
                  paint={{
                    "line-color": "#0000FF", // Blue
                    "line-width": 8,
                  }}
                />

                <Layer
                  id="driver-lines"
                  type="symbol"
                  layout={{
                    "symbol-placement": "line",
                    "text-field": "<",
                    "text-size": 18,
                    "symbol-spacing": 40,
                    "text-rotation-alignment": "map",
                    "text-keep-upright": true,
                  }}
                  paint={{
                    "text-color": "#ffffff",
                  }}
                />
              </Source>
            )}

            {renderGreenRouteAndYellowPins()}

            {Array.isArray(locationTab?.locations) &&
              locationTab.locations.length > 0 &&
              locationTab.locations.map((location, index) => {
                const lat = parseFloat(location.Lat);
                const lng = parseFloat(location.Lng);
                if (
                  isNaN(lat) ||
                  isNaN(lng) ||
                  lat < -90 ||
                  lat > 90 ||
                  lng < -180 ||
                  lng > 180
                ) {
                  console.warn("Invalid location coordinates", location);
                  return null;
                }

                const handleClickGeoLocation = (index) => {
                  setHoveredIndex(index);
                };

                return (
                  <React.Fragment key={index}>
                    <Marker
                      latitude={lat}
                      longitude={lng}
                      anchor="bottom"
                      // onClick={() => setHoveredIndex(index)}
                      onClick={() => handleClickGeoLocation(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <EventPin style={{ height: "24px", width: "24px" }} />
                    </Marker>

                    {hoveredIndex === index && (
                      <Popup
                        latitude={lat}
                        longitude={lng}
                        closeButton={true}
                        closeOnClick={false}
                        anchor="top"
                        offset={[0, -20]}
                        onClose={() => setHoveredIndex(null)}
                      >
                        <div style={{ lineHeight: "1.5", fontSize: "13px" }}>
                          <div style={{ color: "#00ACC1", fontWeight: "bold" }}>
                            {EVTYPE_MAP[location.EVTYPE] || "Unknown"}&nbsp;
                            <span style={{ fontWeight: "normal" }}>
                              On {formatDateTime(location.CREATED)}
                            </span>
                          </div>
                          <div>
                            <span style={{ color: "gray" }}>Driver - </span>
                            <span style={{ color: "#00ACC1", fontWeight: 500 }}>
                              {location.UserName || "N/A"}
                            </span>
                          </div>
                        </div>
                      </Popup>
                    )}
                  </React.Fragment>
                );
              })}
            {containerDetailMap &&
              containerDetailMap.FLatitude &&
              containerDetailMap.FLongitude &&
              status !== 4 && (
                <>
                {((mapType === "cargo" && status !== 3) || (mapType === "default" && status !== 4)) && 
                  <Marker
                    latitude={Number(containerDetailMap.FLatitude)}
                    longitude={Number(containerDetailMap.FLongitude)}
                    anchor="bottom"
                    onClick={() => setSelectedLocation(containerDetailMap)}
                  >
                    <Pin
                      style={{
                        width: "40px",
                        height: "40px",
                        cursor: "pointer",
                      }}
                    />
                  </Marker>
                }
                 
                  {selectedLocation === containerDetailMap && !triptrack && (
                    <Popup
                      latitude={Number(containerDetailMap.FLatitude)}
                      longitude={Number(containerDetailMap.FLongitude)}
                      closeButton={true}
                      closeOnClick={false}
                      anchor="top"
                      onClose={() => setSelectedLocation(null)}
                    >
                      <div
                        style={{
                          minWidth: 260,
                          background: "#E1FFED",
                          borderRadius: 12,
                          padding: 12,
                          marginBottom: 8,
                        }}
                      >
                        <div style={{ fontWeight: 500, fontSize: 15 }}>
                          {containerDetailMap.FAssetID}
                        </div>
                        <div
                          style={{
                            color: "#979797",
                            fontSize: 14,
                            marginBottom: 4,
                          }}
                        >
                          {companyName?.[0]?.FAgentName}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#979797",
                            fontWeight: 400,
                            fontSize: "14px",
                            marginBottom: 0,
                          }}
                        >
                          <span style={{ fontSize: 18, marginRight: 4 }}>
                            {containerDetailMap.FLockStatus === 0 ? (
                              <Lock width={18} height={18} />
                            ) : (
                              <RedUnlock width={18} height={18} />
                            )}
                          </span>
                          {containerDetailMap.FLockStatus === 0
                            ? "Locked"
                            : "Unlocked"}
                        </div>
                      </div>
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: 12,
                          padding: 12,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Speed</span>
                          <span style={{ color: "#979797" }}>
                            {containerDetailMap.FSpeed ?? 0}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Mileage</span>
                          <span style={{ color: "#979797" }}>
                            {containerDetailMap.FMileage ?? 0}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Battery</span>
                          <span style={{ color: "#979797" }}>
                            {containerDetailMap.FBattery ?? 0}%
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Gps Time</span>
                          <span style={{ color: "#979797" }}>
                            {containerDetailMap.FGPSTime
                              ? new Date(
                                  containerDetailMap.FGPSTime
                                ).toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                              : "--:--"}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Lat, Long</span>
                          <span style={{ color: "#979797" }}>
                            {containerDetailMap.FLatitude},{" "}
                            {containerDetailMap.FLongitude}
                          </span>
                        </div>
                        <div>
                          <span>Status</span>
                          <div
                            style={{
                              color: "#979797",
                              fontSize: 14,
                              marginLeft: 14,
                              display: "grid",
                              gridTemplateColumns: "120px auto",
                              rowGap: "6px",
                              justifyItems: "end", // This aligns all grid items to the right
                            }}
                          >
                            <div style={{ textAlign: "right" }}>Lock Rope:</div>
                            <div style={{ textAlign: "right" }}>
                              {containerDetailMap.FLockRope === 0
                                ? "Insert"
                                : "Pull out"}
                            </div>

                            <div style={{ textAlign: "right" }}>
                              Lock State:
                            </div>
                            <div style={{ textAlign: "right" }}>
                              {containerDetailMap.FLockStatus === 0
                                ? "Locked"
                                : "Unlocked"}
                            </div>

                            <div style={{ textAlign: "right" }}>
                              Back Cover:
                            </div>
                            <div style={{ textAlign: "right" }}>
                              {(() => {
                                try {
                                  const desc = JSON.parse(
                                    containerDetailMap.FExpandProto?.FDesc ||
                                      "{}"
                                  );
                                  return desc.fBackCover === 0
                                    ? "Closed"
                                    : "Open";
                                } catch {
                                  return "-";
                                }
                              })()}
                            </div>

                            <div style={{ textAlign: "right" }}>LBS:</div>
                            <div style={{ textAlign: "right" }}>
                              {containerDetailMap.FCELLID || "-"}
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Location</span>
                          <span
                            style={{
                              color: "#979797",
                              maxWidth: "180px", // adjust as needed
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              textAlign: "right",
                              display: "block",
                            }}
                          >
                            {mapLocationName}
                          </span>
                        </div>
                      </div>
                    </Popup>
                  )}

                  {selectedLocation === containerDetailMap && !trackLink && (
                    <Newbox>
                      {" "}
                      <Popup
                        latitude={Number(containerDetailMap.FLatitude)}
                        longitude={Number(containerDetailMap.FLongitude)}
                        closeButton={true}
                        closeOnClick={false}
                        anchor="top"
                        onClose={() => setSelectedLocation(null)}
                        className="popupcontainer_tracklink"
                      >
                        <div class="popup_container">
                          <div class="popup_header">
                            <h4>{containerDetailMap.FAssetID}</h4>
                            <span>{companyName?.[0]?.FAgentName}</span>
                          </div>

                          <div className="CONTAINER_THREE_tracklink">
                            <div class="popup_body">
                              <p className="loca_one">Location:</p>
                              <p className="loc_two">
                                {containerDetailMap?.locationName}
                              </p>
                            </div>
                            <div class="popup_body">
                              <p className="loca_one">Speed:</p>
                              <p className="loc_two">
                                {containerDetailMap?.FSpeed ?? "-"}
                              </p>
                            </div>
                            <div class="popup_body">
                              {" "}
                              <p className="loca_one">Mileage:</p>
                              <p className="loc_two">
                                {containerDetailMap?.FMileage ?? "-"}
                              </p>
                            </div>
                            {/* TraKing vehicles (Nexus) have no battery reading */}
                            {containerDetailMap?.FBattery !== null && (
                              <div class="popup_body">
                                {" "}
                                <p className="loca_one">Battery:</p>
                                <p className="loc_two">
                                  {containerDetailMap?.FBattery ?? "-"}
                                </p>
                              </div>
                            )}
                            <div class="popup_body">
                              {" "}
                              <p className="loca_one">Gps Time:</p>
                              <p className="loc_two">
                                {getFormattedDateTime(
                                  containerDetailMap?.mileage
                                ) ?? "-"}
                              </p>
                            </div>
                            <div class="popup_body">
                              {" "}
                              <p className="loca_one">Run Status:</p>
                              <p className="loc_two">
                                {containerDetailMap?.runstatus ?? "-"}
                              </p>
                            </div>
                            <div class="popup_body">
                              {" "}
                              <p className="loca_one">Lat, Lng:</p>
                              <p className="loc_two">
                                {containerDetailMap?.FLatitude}, {
                                  containerDetailMap?.FLongitude}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Popup>
                    </Newbox>
                  )}
                </>
              )}

            {/* Removed locationsRoute polyline to ensure only one green route line is shown */}

            {route && (
              <Source
                id="route"
                type="geojson"
                data={{ type: "Feature", geometry: route }}
              >
                <Layer
                  id="route-line"
                  type="line"
                  paint={{ "line-color": "#007AFF", "line-width": 4 }}
                />
              </Source>
            )}
            {/* Zoom & Scroll Control */}
            <NavigationControl
              onViewportChange={setViewport}
              position="top-right"
            />
            {data?.length > 0 && (
              <>
                {data?.map((item, index) => {
                  const lat = parseFloat(item.lat);
                  const lng = parseFloat(item.long);
                  if (
                    isNaN(lat) ||
                    isNaN(lng) ||
                    lat < -90 ||
                    lat > 90 ||
                    lng < -180 ||
                    lng > 180
                  ) {
                    console.warn("Invalid data coordinates:", item);
                    return null;
                  }

                  return (
                    <Marker
                      key={index}
                      latitude={lat}
                      longitude={lng}
                      anchor="bottom"
                    >
                      <EventPin style={{ fontSize: "24px", color: "red" }} />
                    </Marker>
                  );
                })}
              </>
            )}
            {pinlocation?.length > 0 && (
              <>
                {pinlocation?.map((item, index) => {
                  const startLat = parseFloat(item.StartLat);
                  const startLng = parseFloat(item.StartLng);
                  const endLat = parseFloat(item.EndLat);
                  const endLng = parseFloat(item.EndLng);

                  if (
                    isNaN(startLat) ||
                    isNaN(startLng) ||
                    isNaN(endLat) ||
                    isNaN(endLng) ||
                    startLat < -90 ||
                    startLat > 90 ||
                    startLng < -180 ||
                    startLng > 180 ||
                    endLat < -90 ||
                    endLat > 90 ||
                    endLng < -180 ||
                    endLng > 180
                  ) {
                    console.warn("Invalid pinlocation coordinates:", item);
                    return null;
                  }

                  return (
                    <React.Fragment key={index}>
                      {/* Start Marker */}
                      <Marker
                        latitude={startLat}
                        longitude={startLng}
                        anchor="bottom"
                        onClick={() => setSelectedLocation(item)}
                      >
                        <div style={{ textAlign: "center" }}>
                          <EnvironmentFilled
                            style={{ fontSize: "24px", color: "red" }}
                          />
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              color: "black",
                            }}
                          >
                            P
                          </div>
                        </div>
                      </Marker>

                      {/* End Marker */}
                      <Marker
                        latitude={endLat}
                        longitude={endLng}
                        anchor="bottom"
                        onClick={() => setSelectedLocation(item)}
                      >
                        <div style={{ textAlign: "center" }}>
                          <EnvironmentFilled
                            style={{ fontSize: "24px", color: "blue" }}
                          />
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              color: "black",
                            }}
                          >
                            D
                          </div>
                        </div>
                      </Marker>
                    </React.Fragment>
                  );
                })}

                {routeGeoJSON && (
                  <Source id="route" type="geojson" data={routeGeoJSON}>
                    <Layer
                      id="route-line"
                      type="line"
                      paint={{
                        "line-color": "green",
                        "line-width": 4,
                      }}
                    />
                  </Source>
                )}

                {selectedLocation && (
                  <Popup
                    latitude={parseFloat(selectedLocation.StartLat)}
                    longitude={parseFloat(selectedLocation.StartLng)}
                    closeButton={true}
                    closeOnClick={false}
                    onClose={() => setSelectedLocation(null)}
                    anchor="top"
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span>
                        <b>Trip:</b> {selectedLocation.TRIPID}
                      </span>
                      <span>
                        <b>Vehicle:</b> {selectedLocation.RegNo}
                      </span>
                      <span>
                        <b>Driver:</b> {selectedLocation.DriverName}
                      </span>
                      <span>
                        <b>Customer:</b> {selectedLocation.CustName}
                      </span>
                    </div>
                  </Popup>
                )}
              </>
            )}

            {Array.isArray(locationsTL) && locationsTL.length > 0 ? (
              locationsTL.map((location, index) => {
                const lat = parseFloat(location.Lat);
                const lng = parseFloat(location.Lng);
                console.warn("locationName:", location);

                if (
                  isNaN(lat) ||
                  isNaN(lng) ||
                  lat < -90 ||
                  lat > 90 ||
                  lng < -180 ||
                  lng > 180
                ) {
                  console.warn("Invalid coordinates for location:", location);
                  return null;
                }

                return (
                  <React.Fragment key={index}>
                    <Marker
                      latitude={lat}
                      longitude={lng}
                      anchor="bottom"
                      onClick={() => handleMarkerClick(index, lat, lng)}

                      // onClick={() => setSelectedMarkerIndex(index)}
                    >
                      <EventPin style={{ fontSize: "24px", color: "yellow" }} />
                    </Marker>
                    {selectedMarkerIndex === index && (
                      <Popup
                        latitude={lat}
                        longitude={lng}
                        closeButton={true}
                        closeOnClick={false}
                        anchor="top"
                        onClose={() => handleMarkerClick(null)}
                        offset={[0, -20]}
                      >
                        {triprackAI && (
                          <>
                            <div style={{ fontSize: "12px" }}>
                              <div>
                                <span style={{ color: "gray" }}>
                                  {" "}
                                  {location.EventName || location.event || "Unknown"} On - {" "}
                                </span>
                                <span
                                  style={{
                                    color: "#00B8D9",
                                    fontWeight: "bold",
                                  }}
                                >
                                {location.MODON
                                  ? moment(location.MODON)
                                      .subtract(3, "hours")
                                      .format("Do MMM YYYY; hh:mm A")
                                  : (location.date && location.time
                                      ? `${location.date} ${location.time}`
                                      : "-")
                                }
                                </span>
                              </div>
                              <div>
                                <span style={{ color: "gray" }}>Driver - </span>
                                <span
                                  style={{
                                    color: "#00B8D9",
                                    cursor: "pointer",
                                    marginLeft: "8px",
                                  }}
                                >
                                  {driverName || "-"}
                                </span>
                              </div>
                              <div>
                                <span style={{ color: "gray" }}>Address - </span>
                                <span
                                  style={{
                                    color: "#00B8D9",
                                    cursor: "pointer",
                                  }}
                                >
                                {resolvedAddresses[`${lat},${lng}`] ||
                                  "Fetching location..."}                                </span>
                              </div>
                            </div>
                          </>
                        )}

                        {tracklinkplus && (
                          <div style={{ fontSize: "12px" }}>
                            <div>
                              <span style={{ color: "gray" }}>
                                {" "}
                                {EVTYPE_MAP[location.EVTYPE] ||
                                  "Uploaded"} On{" "}
                              </span>
                              <span
                                style={{ color: "#00B8D9", fontWeight: "bold" }}
                              >
                                {dayjs(location.MODON).isValid()
                                  ? dayjs(location.MODON).format(
                                      "Do MMM YYYY; hh:mm A"
                                    )
                                  : "14:40 PM, 12 Jun 2025"}
                              </span>
                            </div>
                            <div>
                              <span style={{ color: "gray" }}>Driver - </span>
                              <span
                                style={{
                                  color: "#00B8D9",
                                  cursor: "pointer",
                                  marginLeft: "5px",
                                }}
                              >
                                {driverNametracklinkplus || ""}
                              </span>
                            </div>
                            <div>
                              <span style={{ color: "gray" }}>Address - </span>
                              <span
                                style={{ color: "#00B8D9", cursor: "pointer" }}
                              >
                                {mapLocationName ||
                                  "Nairobi, Nairobi County, Kenya"}
                              </span>
                            </div>
                          </div>
                        )}
                        {!triprackAI && !tracklinkplus && (
                          <div style={{ fontSize: "12px" }}>
                            {fromFiles == false && (
                            <div>
                              <span style={{ color: "gray" }}>
                                {" "}
                                {EVTYPE_MAP[location.EVTYPE] ||
                                  "Uploaded"} On{" "}
                              </span>
                              <span
                                style={{ color: "#00B8D9", fontWeight: "bold" }}
                              >
                                {dayjs(location.MODON).isValid()
                                  ? dayjs(location.MODON).format(
                                      "Do MMM YYYY; hh:mm A"
                                    )
                                  : "14:40 PM, 12 Jun 2025"}
                              </span>
                            </div>)}
                            {fromFiles == true && (
                            <div>
                              <span style={{ color: "gray" }}>
                                {" "}
                                {EVTYPE_MAP[location.EVTYPE] ||
                                  "Uploaded"} On{" "}
                              </span>
                              <span
                                style={{ color: "#00B8D9", fontWeight: "bold" }}
                              >
                                {dayjs(location.CRON).isValid()
                                  ? dayjs(location.CRON).format(
                                      "Do MMM YYYY; hh:mm A"
                                    )
                                  : "14:40 PM, 12 Jun 2025"}
                              </span>
                            </div>
                            )}
                            {fromFiles == false && (
                            <div>
                              <span style={{ color: "gray" }}>Driver - </span>
                              <span
                                style={{ color: "#00B8D9", cursor: "pointer" }}
                              >
                                {driverNametracklinkplus || ""}
                              </span>
                            </div>
                            )}
                            {fromFiles == true && (
                            <div>
                              <span style={{ color: "gray" }}>Uploaded By - </span>
                              <span
                                style={{ color: "#00B8D9", cursor: "pointer" }}
                              >
                                {location.AddedBy || ""}
                              </span>
                            </div>
                            )}
                            <div>
                              <span style={{ color: "gray" }}>Address - </span>
                              <span
                                style={{ color: "#00B8D9", cursor: "pointer" }}
                              >
                                {resolvedAddresses[`${lat},${lng}`] ||
                                  "Fetching location..."}
                              </span>
                            </div>
                          </div>
                        )}
                      </Popup>
                    )}
                  </React.Fragment>
                );
              })
            ) : (
              <div> </div>
            )}
            {Array.isArray(locationsTLAI) && locationsTLAI.length > 0 ? (
              <>
                {/* 🚚 Truck at Last Event */}
                {(() => {
                  if (status !== 4) return null;
                  const validPoints = (
                    Array.isArray(locationsTLAI) ? locationsTLAI : []
                  ).filter(
                    (loc) =>
                      (loc.LAT &&
                        loc.LNG &&
                        !isNaN(loc.LAT) &&
                        !isNaN(loc.LNG)) ||
                      (loc.Lat && loc.Lng && !isNaN(loc.Lat) && !isNaN(loc.Lng))
                  );

                  if (validPoints.length >= 2) {
                    const secondLast = validPoints[validPoints.length - 2];

                    const last = validPoints[validPoints.length - 1];

                    const lat1 =
                      parseFloat(secondLast.LAT) || parseFloat(secondLast.Lat);
                    const lng1 =
                      parseFloat(secondLast.LNG) || parseFloat(secondLast.Lng);
                    const lat2 =
                      parseFloat(last.LAT) || parseFloat(secondLast.Lng);
                    const lng2 =
                      parseFloat(last.LNG) || parseFloat(secondLast.Lng);

                    // Midpoint logic
                    const midLat = (lat1 + lat2) / 2;
                    const midLng = (lng1 + lng2) / 2;

                    return (
                      <>
                        <Marker
                          latitude={midLat}
                          longitude={midLng}
                          anchor="bottom"
                        >
                          <img
                            src={truckIcon}
                            alt="truck"
                            style={{
                              width: "50px",
                              height: "auto",
                              cursor: "pointer",
                            }}
                            onClick={() => setShowTruckPopup(true)}
                          />
                        </Marker>
                        {showTruckPopup && triptracktruckicon && (
                          <Popup
                            latitude={midLat}
                            longitude={midLng}
                            closeButton={true}
                            closeOnClick={false}
                            anchor="top"
                            onClose={() => setShowTruckPopup(false)}
                          >
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <span style={{ fontWeight: 600, fontSize: 18 }}>
                                  {tripListData[0]?.VEHREGNO || "--"}
                                </span>
                                <span
                                  style={{
                                    color: "#979797",
                                    fontSize: 13,
                                    fontStyle: "italic",
                                    marginLeft: "20px",
                                  }}
                                >
                                  {validPoints[0]?.MODON
                                    ? new Date(
                                        validPoints[0]?.MODON
                                      ).toLocaleString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                      })
                                    : "--"}
                                </span>
                              </div>
                              <div
                                style={{
                                  margin: "8px 0",
                                  color: "#222",
                                  fontSize: 15,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <FaMapMarkerAlt
                                  color="red"
                                  style={{ marginRight: 6 }}
                                />
                                <span style={{ color: "#5f6d8c" }}>
                                  {locationName[0]?.LastlocationName
                                    ? locationName[0]?.LastlocationName
                                    : "-"}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  color: "#13b94b",
                                  fontSize: 15,
                                }}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  style={{ marginRight: 6 }}
                                  viewBox="0 0 24 24"
                                  fill="#13b94b"
                                >
                                  <circle cx="12" cy="12" r="10" />
                                  <path
                                    d="M8 13l2.5 2.5L16 10"
                                    stroke="#fff"
                                    strokeWidth="2"
                                    fill="none"
                                  />
                                </svg>
                                <span>
                                  {tripListData[0]?.DistanceCovered
                                    ? `${tripListData[0]?.DistanceCovered} km`
                                    : `${tripListData[0]?.DistanceCovered} km`}
                                </span>
                              </div>
                            </div>
                          </Popup>
                        )}
                        
                        {showTruckPopup && trackLinktruckicon && (
                          <Popup
                            latitude={midLat}
                            longitude={midLng}
                            closeButton={true}
                            closeOnClick={false}
                            anchor="top"
                            onClose={() => setShowTruckPopup(false)}
                          >
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <span style={{ fontSize: 18 }}>
                                  {timeandDistAI[0]?.FVehicleName || "--"}
                                </span>
                                <span
                                  style={{
                                    color: "#979797",
                                    fontSize: 13,
                                    fontStyle: "italic",
                                    marginLeft: "20px",
                                  }}
                                >
                                  {locationsTLAI?.length
                                    ? moment(
                                        locationsTLAI[locationsTLAI.length - 1]
                                          ?.MODON
                                      )
                                        .subtract(3, "hours")
                                        .format("Do MMM YYYY; hh:mm A")
                                    : "-"}
                                </span>
                              </div>
                              <div
                                style={{
                                  margin: "8px 0",
                                  color: "#222",
                                  fontSize: 15,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <FaMapMarkerAlt
                                  color="red"
                                  style={{ marginRight: 6 }}
                                />
                                <span style={{ color: "#5f6d8c" }}>
                                  {lastLocationName || "--"}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  color: "#13b94b",
                                  fontSize: 15,
                                }}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  style={{ marginRight: 6 }}
                                  viewBox="0 0 24 24"
                                  fill="#13b94b"
                                >
                                  <circle cx="12" cy="12" r="10" />
                                  <path
                                    d="M8 13l2.5 2.5L16 10"
                                    stroke="#fff"
                                    strokeWidth="2"
                                    fill="none"
                                  />
                                </svg>
                                <span>
                                  {timeandDistAI[0]?.TransportationMileage
                                    ? `${timeandDistAI[0]?.TransportationMileage} km`
                                    : `${timeandDistAI[0]?.TransportationMileage} km`}
                                </span>
                              </div>
                            </div>
                          </Popup>
                        )}

                        {showTruckPopup && tracklinkAiplus && (
                          <Popup
                            latitude={midLat}
                            longitude={midLng}
                            closeButton={true}
                            closeOnClick={false}
                            anchor="top"
                            onClose={() => setShowTruckPopup(false)}
                          >
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <span style={{ fontSize: 18 }}>
                                  {summaryData?.RegNo || "--"}
                                </span>
                                <span
                                  style={{
                                    color: "#979797",
                                    fontSize: 13,
                                    fontStyle: "italic",
                                    marginLeft: "20px",
                                  }}
                                >
                                  {locationsTLAI[0]?.MODON
                                    ? new Date(
                                        locationsTLAI[0]?.MODON
                                      ).toLocaleString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                      })
                                    : "--"}
                                </span>
                              </div>
                              <div
                                style={{
                                  margin: "8px 0",
                                  color: "#222",
                                  fontSize: 15,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <FaMapMarkerAlt
                                  color="red"
                                  style={{ marginRight: 6 }}
                                />
                                <span style={{ color: "#5f6d8c" }}>
                                  {triptracklinklocationAI || "--"}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  color: "#13b94b",
                                  fontSize: 15,
                                }}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  style={{ marginRight: 6 }}
                                  viewBox="0 0 24 24"
                                  fill="#13b94b"
                                >
                                  <circle cx="12" cy="12" r="10" />
                                  <path
                                    d="M8 13l2.5 2.5L16 10"
                                    stroke="#fff"
                                    strokeWidth="2"
                                    fill="none"
                                  />
                                </svg>
                                <span>
                                  {locationsTLAI[0]?.TransportationMileage
                                    ? `${locationsTLAI[0]?.TransportationMileage} km`
                                    : "-"}
                                </span>
                              </div>
                            </div>
                          </Popup>
                        )}
                      </>
                    );
                  }
                  return null;
                })()}

                {/* 📍 Marker Pins */}
                {locationsTLAI.map((location, index) => {
                  const lat = parseFloat(location.LAT || location.lat);
                  const lng = parseFloat(location.LNG || location.lng);

                  if (
                    isNaN(lat) ||
                    isNaN(lng) ||
                    lat < -90 ||
                    lat > 90 ||
                    lng < -180 ||
                    lng > 180
                  ) {
                    console.warn("Invalid coordinates for location:", location);
                    return null;
                  }

                  return (
                    <React.Fragment key={index}>
                      <Marker
                        latitude={lat}
                        longitude={lng}
                        anchor="bottom"
                        onClick={() => handleMarkerClick(index, lat, lng)}
                      >
                        <FaMapMarkerAlt color="yellow" size={26} />
                      </Marker>

                      {selectedMarkerIndex === index && (
                        <Popup
                          latitude={lat}
                          longitude={lng}
                          closeButton={true}
                          closeOnClick={false}
                          anchor="top"
                          onClose={() => setSelectedMarkerIndex(null)}
                          offset={[0, -20]}
                        >
                          <div
                            style={{
                              fontFamily: "sans-serif",
                              maxWidth: "280px",
                              padding: "10px",
                              borderRadius: "20px",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                marginBottom: "5px",
                              }}
                            >
                              {location.EventName || "Unknown"}
                            </div>
                            <div
                              style={{
                                color: "#555",
                                fontSize: "13px",
                                marginBottom: "10px",
                              }}
                            >
                            {location.MODON || location.finishedTime
                              ? moment(location.MODON || location.finishedTime)
                                  .subtract(location.FENCENAME ? 3 : 5.5, "hours")
                                  .format("Do MMM YYYY; hh:mm A")
                              : "-"}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "6px",
                              }}
                            >
                              <FaMapMarkerAlt
                                color="red"
                                size={14}
                                style={{ marginTop: "3px" }}
                              />
                              <div style={{ fontSize: "13px", color: "#444" }}>
                                {resolvedAddresses[`${lat},${lng}`] ||
                                  "Fetching location..."}
                              </div>
                            </div>
                          </div>
                        </Popup>
                      )}
                    </React.Fragment>
                  );
                })}
              </>
            ) : (
              <div> </div>
            )}

            {Array.isArray(tripEvent) && tripEvent.length > 0 ? (
              tripEvent.map((location, index) => {
                const lat = parseFloat(location.Lat) || "-1.3847331";
                const lng = parseFloat(location.Lng) || "36.9388587";
                // Validate coordinates
                if (
                  isNaN(lat) ||
                  isNaN(lng) ||
                  lat < -90 ||
                  lat > 90 ||
                  lng < -180 ||
                  lng > 180
                ) {
                  console.warn("Invalid coordinates for location:", location);
                  return null;
                }

                return (
                  <Marker
                    key={index}
                    latitude={lat}
                    longitude={lng}
                    anchor="bottom"
                  >
                    {isminimap ? (
                      <EventPin style={{ fontSize: "24px", color: "red" }} />
                    ) : (
                      <EventPin style={{ fontSize: "24px", color: "red" }} />
                    )}
                  </Marker>
                );
              })
            ) : (
              <div> </div>
            )}
            {locationsRoute && (
              <Source id="route-source" type="geojson" data={locationsRoute}>
                <Layer
                  id="route-layer"
                  type="line"
                  paint={{
                    "line-color": "#ff0000", // 🔴 red line
                    "line-width": 4,
                    "line-opacity": 0.8,
                  }}
                />
              </Source>
            )}
          </InteractiveMap>
        )}
        {/* <div
          style={{
            width: `${size.width}px`,
            height: `${size.height}px`,
            background: "#F0F0F0",
            // display: "flex",
            // alignItems: "center",
            // justifyContent: "center",
          }}
          // className="map_container_REUSABLE_one"
        >
        
        </div> */}
      </div>
    </>
  );
};

export default MapComponent;
